import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Card, Dropdown, Form, Grid, Menu, Pagination, Table } from 'semantic-ui-react';
import PageContainer from '../../common/PageContainer';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import * as moment from 'moment-timezone';
import { SERVER_URL } from '../../../constants';
import { useFormik } from 'formik';
import { PromoStatusLabel } from '../DigestStatusLabel';
import * as api from './../../../api/campaignApi';

export const HomesOfTheWeekSearch = ({
  cities,
  getHotw,
  hotw,
  clearRecentPosts,
  searchHOTW,
  addHotw,
  hotwAlertFormats,
  hotwQuery,
  setHotwQuery,
}) => {
  const search = async query => {
    setHotwQuery(query);
    const { digests, count } = await api.searchHOTW({ ...query, column, direction });
    setCount(count);
    setDigests(digests);
  };

  useEffect(() => {
    clearRecentPosts();
    search(hotwQuery);
  }, []);

  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [digests, setDigests] = useState([]);
  const [column, setColumn] = useState('sendDate');
  const [direction, setDirection] = useState('DESC');

  const formik = useFormik({
    initialValues: hotwQuery,
    onSubmit: search,
    enableReinitialize: true,
  });

  const getDate = alert => {
    const sendDate = moment.utc(parseInt(alert.sendDate));
    const sendTime = moment(alert.sendTime, 'hh:mm');

    if (!sendDate.isValid()) return;

    if (sendDate.isValid() && !sendTime.isValid()) {
      return sendDate.format('MMM D, YYYY');
    }

    return `${moment.utc(parseInt(alert.sendDate)).format('MMM D, YYYY')}, ${moment(alert.sendTime, 'hh:mm').format(
      'h:mm a'
    )}`;
  };

  const getDirection = () => {
    if (direction === 'ASC') {
      return 'descending';
    }
    if (direction === 'DESC') {
      return 'ascending';
    }
    return null;
  };

  return (
    <>
      <PageContainer>
        <Menu borderless attached="top">
          <Menu.Item header>Homes of the Week</Menu.Item>

          <Menu.Menu position="right">
            <Menu.Item>
              <Dropdown text="New Email" icon="plus" labeled button className="button icon positive">
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => addHotw('Homes of the Week')}>Homes of the Week</Dropdown.Item>
                  <Dropdown.Item onClick={() => addHotw('Showcase')}>Showcase</Dropdown.Item>
                  <Dropdown.Item onClick={() => addHotw('Gift Guide')}>Gift Guide</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Menu.Item>
          </Menu.Menu>
        </Menu>

        <br />

        <Grid>
          <Grid.Column computer={13}>
            <Table compact="very" size="small" celled sortable fixed>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell collapsing style={{ width: 50 }}></Table.HeaderCell>
                  <Table.HeaderCell
                    width={6}
                    sorted={column === 'subject' ? getDirection() : null}
                    onClick={() => {
                      if (column !== 'subject') {
                        setDirection(null);
                      }
                      setColumn('subject');
                      setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
                      search(formik.values);
                    }}
                  >
                    Subject line
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    width={2}
                    sorted={column === 'style' ? getDirection() : null}
                    onClick={() => {
                      if (column !== 'style') {
                        setDirection(null);
                      }
                      setColumn('style');
                      setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
                      search(formik.values);
                    }}
                  >
                    Style
                  </Table.HeaderCell>
                  <Table.HeaderCell width={2}>City</Table.HeaderCell>
                  <Table.HeaderCell
                    width={3}
                    sorted={column === 'sendDate' ? getDirection() : null}
                    onClick={() => {
                      if (column !== 'sendDate') {
                        setDirection(null);
                      }
                      setColumn('sendDate');
                      setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
                      search(formik.values);
                    }}
                  >
                    Send on
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    size={2}
                    sorted={column === 'isScheduled' ? getDirection() : null}
                    onClick={() => {
                      if (column !== 'isScheduled') {
                        setDirection(null);
                      }
                      setColumn('isScheduled');
                      setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
                      search(formik.values);
                    }}
                  >
                    Status
                  </Table.HeaderCell>
                  <Table.HeaderCell collapsing style={{ width: 50 }}></Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {digests?.length > 0 &&
                  digests.map((email, idx) => (
                    <Table.Row key={idx}>
                      <Table.Cell collapsing>
                        <Link to={'/hotw/create/' + email.id}>
                          <Button size="tiny" icon="edit" />
                        </Link>
                      </Table.Cell>
                      <Table.Cell>
                        <Link to={'/hotw/create/' + email.id}>{email.subject}</Link>
                      </Table.Cell>
                      <Table.Cell>{email.style}</Table.Cell>
                      <Table.Cell>{email?.site?.city}</Table.Cell>
                      <Table.Cell>{getDate(email)}</Table.Cell>
                      <Table.Cell>
                        <PromoStatusLabel digest={email} />
                      </Table.Cell>
                      <Table.Cell>
                        <Button
                          icon="binoculars"
                          as="a"
                          size="mini"
                          target="_blank"
                          href={`${SERVER_URL}/api/hotw/email/${email.id}`}
                        />
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>

            <br />

            <div style={{ display: 'grid', justifyContent: 'center' }}>
              <Pagination
                activePage={page}
                style={{ marginLeft: 'auto', marginRight: 'auto' }}
                totalPages={Math.ceil(count / 10)}
                onPageChange={(e, { activePage }) => {
                  console.log({ page, activePage });
                  formik.setFieldValue('offset', 10 * (activePage - 1));
                  formik.handleSubmit();
                  setPage(activePage);
                }}
              />
            </div>
          </Grid.Column>
          <Grid.Column computer={3}>
            <Form onSubmit={formik.handleSubmit}>
              <div style={{ display: 'grid', alignItems: 'start' }}>
                <Card fluid>
                  <Card.Content>
                    <Form.Field>
                      <label>Subject</label>
                      <Form.Input
                        icon="search"
                        name="subject"
                        value={formik.values.subject}
                        onChange={(e, { value }) => formik.setFieldValue('subject', value)}
                      />
                    </Form.Field>

                    <br />

                    <Form.Field>
                      <label>City</label>
                      <Form.Dropdown
                        name="siteId"
                        clearable
                        className="time-dropdown"
                        value={formik.values.siteId}
                        onChange={(e, { value }) => formik.setFieldValue('siteId', value)}
                        fluid
                        selection
                        options={cities}
                        // options={sites ? [{ key: ' ', value: '', text: 'All' }, ...sites.filter(s => s.key)] : []}
                      />
                    </Form.Field>

                    <br />

                    <Form.Field>
                      <label>Style</label>
                      <Form.Dropdown
                        value={formik.values.style}
                        fluid
                        name="style"
                        clearable
                        // placeholder="All"
                        selection
                        options={hotwAlertFormats}
                        onChange={(e, { value }) => formik.setFieldValue('style', value)}
                      />
                    </Form.Field>

                    <br />

                    <Form.Field>
                      <label>Status</label>
                      <Form.Dropdown
                        value={formik.values.status}
                        fluid
                        name="status"
                        clearable
                        // placeholder="All"
                        selection
                        options={['All', 'Draft', 'Scheduled'].map(s => ({ key: s, value: s, text: s }))}
                        onChange={(e, { value }) => formik.setFieldValue('status', value)}
                      />
                    </Form.Field>

                    <br />

                    <Button type="submit" content="Submit" positive fluid />
                    <br />

                    <Button
                      content="Clear"
                      onClick={() => {
                        setHotwQuery();
                        formik.handleSubmit();
                      }}
                      fluid
                    />
                  </Card.Content>
                </Card>
              </div>
            </Form>
          </Grid.Column>
        </Grid>
      </PageContainer>
    </>
  );
};

const mapStateToProps = state => ({
  hotw: selectors.campaigns.homesOfTheWeek(state),
  cities: selectors.admin.cultureMapCities(state),
  hotwAlertFormats: selectors.campaigns.hotwAlertFormats(state),
  hotwQuery: selectors.campaigns.hotwQuery(state),
});

const mapDispatchToProps = dispatch => ({
  getHotw: bindActionCreators(actions.campaign.getHotw, dispatch),
  deleteHotwById: bindActionCreators(actions.campaign.deleteHotwById, dispatch),
  clearRecentPosts: bindActionCreators(actions.campaign.clearRecentPosts, dispatch),
  searchHOTW: bindActionCreators(actions.campaign.searchHOTW, dispatch),
  addHotw: bindActionCreators(actions.campaign.addHotw, dispatch),
  setHotwQuery: bindActionCreators(actions.campaign.setHotwQuery, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomesOfTheWeekSearch);
